<template>
  <div class="list">
    <div class="header">
      <div class="l">
        <div class="label">
          优惠券状态
        </div>
        <el-select
          v-model="searchForm.valid"
          placeholder="请选择优惠券状态"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in couponValidList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <div class="label">
          优惠券类型
        </div>
        <el-select
          v-model="searchForm.couponType"
          placeholder="请选择优惠券类型"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in couponTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="r">
        <el-button
          type="primary"
          size="middle"
          @click="create(null)"
        >
          新建优惠券
        </el-button>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :table-column="tableColumn"
      :pagination="true"
      @changeBypagination="tableHandle"
      @buttonClick="buttonClick"
    />
    <coupon-dialog
      :dialog-visible.sync="couponDialogVisible"
      :item.sync="activeCouponItem"
      @confirm="getList()"
    />
  </div>
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import types, { couponValidList, couponTypeList } from '@/config';
import couponDialog from './dialog/couponDialog.vue';

export default {
  name: 'Order',
  components: {
    dataTable,
    couponDialog,
  },
  data() {
    return {
      couponValidList,
      couponTypeList,
      couponDialogVisible: false,
      searchForm: {
        couponType: null,
        valid: null,
        pageNum: 1,
        pageSize: 10,
      },
      activeCouponItem: null,
      tabelData: {},
      tableColumn: [
        {
          key: 'id',
          label: '优惠券id',
          dataType: 'text',
        },
        {
          key: 'couponName',
          label: '优惠券名称',
          dataType: 'text',
        },
        {
          key: 'couponType',
          label: '优惠券类型',
          dataType: 'function',
          render: (key) => couponTypeList.filter((item) => item.value === key),
        },
        {
          key: 'courseName',
          label: '课程名称',
          dataType: 'text',
        },
        {
          key: 'discountFee',
          label: '优惠金额',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'expireDayCount',
          label: '过期天数',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'valid',
          label: '状态',
          width: '100px',
          dataType: 'function',
          render: (key) => couponValidList.filter((item) => item.value === key),
        },
        {
          key: 'createAt',
          label: '创建时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'control',
          label: '操作',
          width: '240px',
          dataType: 'component',
          renderProps: [
            {
              text: '禁用', renderKey: types.COUPON_ENABLE, renderProp: 'valid', type: 'success', eventIndex: 0, disableKey: null,
            },
            {
              text: '启用', renderKey: types.COURSE_DISABLE, renderProp: 'valid', eventIndex: 0, disableKey: null,
            },
            {
              text: '编辑', renderKey: null, type: 'primary', eventIndex: 1, disableKey: null,
            },
            {
              text: '删除', renderKey: null, type: 'danger', eventIndex: 2, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取列表
    async getList(num = 1) {
      this.searchForm.pageNum = num;
      const result = await axClient.coupon.couponPage(this.searchForm);
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    // 跳转到详情
    goDetails(item) {
      this.$router.push({ name: 'EvaluationDetails', params: { id: item.id } });
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.confirmDialog(item, item.valid === types.COUPON_ENABLE
            ? types.COURSE_DISABLE : types.COUPON_ENABLE);
          break;
        case 1:
          this.create(item);
          break;
        case 2:
          this.confirmDialog(item, 20);
          break;
        default:
          break;
      }
    },
    // 新增优惠券
    create(item) {
      this.activeCouponItem = item;
      this.couponDialogVisible = true;
    },
    // 启用/禁用 优惠券
    confirmDialog(item, valid) {
      this.$confirm('确定启用/禁用/删除该优惠券？', '启用/禁用/删除优惠券', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { id } = item;
        const data = await axClient.coupon.couponUpdateValid(
          {
            id,
            valid,
          },
        );
        if (data) {
          this.$message.success('启用/禁用/删除成功');
          this.getList();
        }
      });
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList(pageNum);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
